// One-shot signal coordinating "fit map to the global event bbox" across
// three kinds of call sites:
//
//   - filter entry points (in map/ + react-ui) — arm the signal when a
//     tag / category / user / partner route is entered.
//   - BeatAPISearchV3Repository (in ts-core/) — reads the signal to decide
//     whether to append include_global_bbox=1 to the next full-viewport
//     search request.
//   - BalloonEventsMapBox (in map/) — reads the response bbox and
//     fits/flies the map, then disarms.
//
// Module-level singleton, no React state, no context. Lives in ts-core so the
// repository can read it without importing from map/. Deliberately not part
// of query state — include_global_bbox is a transient request-shaping concern
// that should not round-trip through URL state.
//
// This signal is consumed exactly once per arm. Two disarm paths:
//   - Normal: armed → repo sets the param → response carries a bbox → the repo
//     stores it and the map component fits the camera and then disarms.
//   - No-fit: the armed request is serviced (2xx) but returns no bbox (e.g. the
//     filtered set has zero events) → the repo disarms immediately, since there
//     is nothing for the map to fit and leaving it armed would let a later
//     search fit unexpectedly. A failed request (e.g. 422 before the viewport
//     is known) is left armed so the next valid request can still fit.

let armed = false;

export const pendingAutoFit = {
  arm(): void {
    armed = true;
  },
  isArmed(): boolean {
    return armed;
  },
  disarm(): void {
    armed = false;
  },
};
